export enum MailingMethods {
  Manual = "Manual",
  StaffHub = "StaffHub",
  Automated = "Automated",
  CSV = "CSV",
}